// extracted by mini-css-extract-plugin
export default {"container":"PowerInfoView_container__-kfJf","container__item":"PowerInfoView_container__item__GdYEv"};